import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { CaseVariableDefinition } from 'dashboard/models/case-variable-definition';
import { dashboardApi } from 'dashboard/redux/api/api';
import { ApiEndpoint, ApiModel, ApiResponse } from 'lib/interfaces/api';

export const caseVariableDefinitionsApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    listCaseVariableDefinitions: builder.query<CaseVariableDefinition[], string | undefined>({
      query: async (caseTemplateId) =>
        await SessionClientDashboard.listResource<CaseVariableDefinition>(
          ApiEndpoint.CaseVariableDefinition,
          {
            filter: {
              'case-template-id': caseTemplateId,
            },
          },
        ).then((response) => response.data || []),
      providesTags: (_result, _error, caseTemplateId) => {
        return [{ type: ApiModel.CaseVariableDefinition, id: caseTemplateId }];
      },
    }),
    createCaseVariableDefinition: builder.mutation<ApiResponse<CaseVariableDefinition>, string>({
      query: async (caseTemplateId) =>
        await SessionClientDashboard.postResourceCreate<CaseVariableDefinition>({
          type: ApiModel.CaseVariableDefinition,
          attributes: {
            'case-template-id': caseTemplateId,
          },
        }),
      invalidatesTags: (_result, _error, caseTemplateId) => {
        return [{ type: ApiModel.CaseVariableDefinition, id: caseTemplateId }];
      },
    }),
    updateCaseVariableDefinition: builder.mutation<CaseVariableDefinition, CaseVariableDefinition>({
      query: async (caseVariableDefinition) =>
        await SessionClientDashboard.updateResource<CaseVariableDefinition>({
          type: ApiModel.CaseVariableDefinition,
          id: caseVariableDefinition.id,
          attributes: {
            key: caseVariableDefinition.attributes.key,
            'variable-definition': caseVariableDefinition.attributes['variable-definition'],
          },
        }),
      invalidatesTags: (_result, _error, caseVariableDefinition) => {
        return [
          {
            type: ApiModel.CaseVariableDefinition,
            id: caseVariableDefinition.attributes['case-template-id'],
          },
        ];
      },
    }),
    archiveCaseVariableDefinition: builder.mutation<CaseVariableDefinition, CaseVariableDefinition>(
      {
        query: async (CaseVariableDefinition) =>
          await SessionClientDashboard.deleteResource<CaseVariableDefinition>(
            ApiEndpoint.CaseVariableDefinition,
            CaseVariableDefinition.id,
          ),
        invalidatesTags: (_result, _error, caseVariableDefinition) => {
          return [
            {
              type: ApiModel.CaseVariableDefinition,
              id: caseVariableDefinition.attributes['case-template-id'],
            },
          ];
        },
      },
    ),
  }),
});

export const {
  useArchiveCaseVariableDefinitionMutation,
  useCreateCaseVariableDefinitionMutation,
  useUpdateCaseVariableDefinitionMutation,
  useListCaseVariableDefinitionsQuery,
} = caseVariableDefinitionsApi;
